import { Component } from '@angular/core';
import { TaskPrintService } from '../../services/tasks/task-print.service';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'fury-task-print',
  templateUrl: './task-print.component.html',
  styleUrls: ['./task-print.component.scss'],
})

export class TaskPrintComponent {

  protected readonly environment = environment;

  constructor(public taskPrintService: TaskPrintService) {
  }
}
